import { render } from "./MediaStudy.vue?vue&type=template&id=ec9dbfcc&scoped=true"
import script from "./MediaStudy.vue?vue&type=script&lang=js"
export * from "./MediaStudy.vue?vue&type=script&lang=js"

import "./MediaStudy.vue?vue&type=style&index=0&id=ec9dbfcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec9dbfcc"]])

export default __exports__